<template>
    <div class="page-detail" v-loading="loading">
        <div v-if="page.bodyType === 0" class="fr-view" v-html="page.body"></div>
        <iframe v-else style="width: 100%; border: none; height: 100%;" :src="page.body"></iframe>
    </div>
</template>

<script>
export default {
    name: 'PageDetail',
    data() {
        return {
            loading: false,
            page: {
                title: ''
            }
        }
    },
    methods: {
        initPage() {
            if (this.$route.query.contentId) {
                this.getContentDetail()
            } else if(this.$route.query.itemId) {
                if (this.$route.path == '/preview') {
                    this.getPreview()
                } else {
                    this.getPageDetail()
                }
            } else {
                this.$router.replace('/error')
            }
        },
        getPageDetail() {
            this.loading = true
            this.$http({
                url: '/v1/content/itemById',
                method: 'get',
                params: {itemId: this.$route.query.itemId}
            }).then(res => {
                this.page = res
                this.$changeTitle(res.title)
                this.loading = false
            }).catch(err => {
                console.info(err)
                this.loading = false
            })
        },
        getPreview() {
            this.loading = true
            this.$http({
                url: '/v1/content/itemPreview',
                method: 'get',
                params: {itemId: this.$route.query.itemId}
            }).then(res => {
                this.page = res
                this.$changeTitle(res.title)
                this.loading = false
            }).catch(err => {
                console.info(err)
                this.loading = false
            })
        },
        getContentDetail() {
            this.loading = true
            this.$http({
                url: '/v1/content/itemByContentId',
                method: 'get',
                params: { contentId: this.$route.query.contentId }
            }).then(res => {
                this.page = res
                this.$changeTitle(res.title)
                this.loading = false
            }).catch(err => {
                console.info(err)
                this.loading = false
            })
        }
    },
    activated() {
        this.initPage()
    },
    deactivated() {
        this.page = {
            title: ''
        }
    }
}
</script>

<style lang="scss">
.page-detail {
    height: 100%;
    padding: 16px;
    box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/views/PageDetail.vue